import React from 'react'
import classnames from 'classnames'
import KeyIcon from '@mui/icons-material/Key'
import CircularProgress from "@mui/material/CircularProgress"
import { useForm } from "react-hook-form"
import {toast} from "react-toastify"

import {useUserContext} from "../../contexts/UserContext"
import {useFormResponse} from "../../hooks/useFormResponse"
import {PasswordInput} from "../../components/PasswordInput"
import {useFetchHook} from "../../hooks/useFetchHook"
import fetcher from "../../fetcher"


export const ChangePassword = () => {
    const { updateProfileResponse } = useUserContext()
    const [changePasswordResponse, changePassword] = useFetchHook(fetcher.changePassword)

    const {
        register,
        handleSubmit,
        setError,
        watch,
        clearErrors,
        formState: { errors },
    } = useForm()

    const onSubmit = (data) => {
        clearErrors()
        changePassword(data)
            .then((data) => {
                if (data?.response?.status === 400) {
                    toast.error("Please correct the errors and try again.")
                } else if (data.status === 200) {
                    toast.success("Successfully changed password.")
                }
            }).catch(() => {
                toast.error("Something went wrong, please try again.")
            })
    }

    useFormResponse(setError, changePasswordResponse, [changePasswordResponse, handleSubmit])

    const isSaving = updateProfileResponse?.loading

    // Disable submit while the two new-password fields disagree. An empty
    // pair counts as "not yet typed" → still enabled so the field can be
    // explored before pressing submit. Match logic only kicks in once both
    // have a value.
    const isDisabled = () => {
        const a = watch('new_password1')
        const b = watch('new_password2')
        if (!a || !b) return false
        return a !== b
    }

    const renderErrors = (field) =>
        errors[field]?.message?.map((message) => (
            <span className={'form-errors'} key={message}>{message}</span>
        ))

    return (
        <div className={'profile-panel ChangePassword'}>
            <div className={'panel-header'}>
                <div className={'panel-title'}>
                    <KeyIcon/>
                    Change Password
                </div>
            </div>
            <div className={'panel-body'}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <PasswordInput
                        {...register('old_password')}
                        placeholder={'Old Password'}
                    />
                    {renderErrors('old_password')}

                    <PasswordInput
                        {...register('new_password1')}
                        placeholder={'New Password'}
                    />
                    {renderErrors('new_password1')}

                    <PasswordInput
                        {...register('new_password2')}
                        placeholder={'Confirm New Password'}
                    />
                    {renderErrors('new_password2')}

                    <button
                        type={'submit'}
                        className={classnames('ChangePassword_button', { disabled: isDisabled() })}
                        disabled={isDisabled()}
                    >
                        {isSaving
                            ? <CircularProgress size={16} color="inherit"/>
                            : 'Change Password'}
                    </button>
                </form>
            </div>
        </div>
    )
}
